import { render, staticRenderFns } from "./EditNode.vue?vue&type=template&id=0c28dc6e&scoped=true"
import script from "./EditNode.vue?vue&type=script&lang=js"
export * from "./EditNode.vue?vue&type=script&lang=js"
import style0 from "./EditNode.vue?vue&type=style&index=0&id=0c28dc6e&prod&lang=scss"
import style1 from "./EditNode.vue?vue&type=style&index=1&id=0c28dc6e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28dc6e",
  null
  
)

export default component.exports